module.exports = __webpack_public_path__ + "img/Front Door Right Salone.8ef09eaa.png";